/**
 * * end of cart upsell block part
 */
$(document).ready(function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cart_total = $(".gb-totals-total-value").first().text();
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector('.premium-attachment-kit') !== null;
    if (hasPremiumKit) { console.log("Premium kit detected - skipping auto free gift trigger"); return; }
    setTimeout(function () {
      var cart_total = $(".gb-totals-total-value").first().text();
      if (cart_total >= amountFreeProduct) {
        if ($(".cart-item").hasClass("gb-find-remove-product")) { console.log("Free product already in cart"); }
        else { console.log("Adding free product"); $(".gb-free-product-trigger").trigger("click"); }
      } else { console.log("Removing free product - under threshold"); $(".gb-remove-product").trigger("click"); }
    }, 3000);
    $("body").on("click", ".gb-sumbit-free", function () {
      setTimeout(function () {
        if (cart_total >= amountFreeProduct) {
          if ($(".cart-item").hasClass("gb-find-remove-product")) {}
          else { $(".gb-free-product-trigger").trigger("click"); }
        } else { $(".gb-remove-product").trigger("click"); }
      }, 3000);
    });
  }

  $("body").on("click", ".gb-shipping-protection-button label.switch", async (e) => {
    if (e.target.tagName == "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem.classList.contains("checked");
    if (!wasChecked) {
      if (spinAnim.style.display == "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");
      const formData = new FormData(form);
      if (!formData.get("id")) { console.error("There is no shipping protection product selected."); return; }
      spinAnim.style.display = "block";
      try {
        const response = await fetch(routes.cart_add_url, { method: "POST", body: formData, headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } });
        if (response.ok) { spinAnim.style.display = "none"; checkElem.style.display = "block"; }
      } catch (err) { console.error("error at shipping protection form submission", err); }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) { updateCartDrawer(cartDrawer, newCartDrawer, true, () => { curElem.classList.remove("unchecked"); curElem.classList.add("checked"); curInputElem.checked = true; }); }
        })
        .catch((_err) => { curElem.classList.remove("unchecked"); curElem.classList.add("checked"); curInputElem.checked = true; });
    } else {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;
      const removeCallback = () => { curElem.classList.remove("checked"); curElem.classList.add("unchecked"); curInputElem.checked = false; };
      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");
      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", { detail: null });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ id: shippingProductId, quantity: 0 }) })
          .then(() => fetch(routes.cart_url + "?view=drawer"))
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) { updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback); }
            else { removeCallback(); }
          })
          .catch(() => { removeCallback(); });
      }
    }
  });

  $("body").on("change", ".gb-change-variant_id", function () {
    var id_change = $(this).find(":selected").attr("data-variant-id");
    if (!id_change) { console.error("No data-variant-id found on selected option"); return; }
    $(this).closest(".gb-get-main-freq-pro").find(".product-variant-id").val(id_change);
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) { console.log("Error: Could not find parent block"); return; }
    const allValues = Array.from(parentBlock.querySelectorAll(".select__select")).map((sel) => sel.value).join(" / ");
    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) { console.log("Error: Could not find variant selector"); return; }
    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));
    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) { console.log("Error: Could not find id input field"); return; }
    if (matchedOption) { idInput.value = matchedOption.value; }
  }
});

document.addEventListener("submit", function (e) {
  if (e.target.action && e.target.action.includes("/cart/add")) {
    const idInput = e.target.querySelector('[name="id"]');
    if (!idInput || !idInput.value) { e.preventDefault(); return false; }
  }
});

$(document).ready(function () {
  $(".cart-item .quantity__button, .cart-item .quantity__input").on("click change input", function () {
    const variantId = $(this).closest(".quantity-input").find(".quantity__input").data("quantity-variant-id");
    if ($(this).closest("form").length > 0) {
      let idInput = $(this).closest("form").find('input[name="id"]');
      if (idInput.length === 0 && variantId) { $("<input>").attr({ type: "hidden", name: "id", value: variantId }).appendTo($(this).closest("form")); }
      else if (idInput.length > 0 && variantId) { idInput.val(variantId); }
    }
  });
  $("#CartDrawer-Checkout").on("click", function (e) {
    const form = $("#CartDrawer-Form");
    if (form.length === 0) return;
    const cartItems = form.find(".cart-item");
    if (cartItems.length === 0) { e.preventDefault(); return false; }
  });
  $(document).on("keydown", ".quantity__input", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) { e.preventDefault(); $(this).trigger("blur"); }
  });
});

$(document).ready(function () {
  $(".gbfrequently-bought-with-main-whole button, .gbfrequently-bought-with-main-whole .gb-sumbit-free, .gb-free-product-trigger, .gb-product-shipping-protection-product-tirgger, .gb-product-sticky-add-to-cart-form").on("click", function (e) {
    const parentBlock = $(this).closest(".gb-get-main-freq-pro, form");
    if (!parentBlock) { console.error("Could not find parent block for frequently bought product"); return; }
    let productId = null;
    const idInput = parentBlock.find('input[name="id"]');
    if (idInput.length > 0 && idInput.val()) { productId = idInput.val(); }
    else if (parentBlock.find(".gb-change-variant_id").length > 0) {
      const selectedOption = parentBlock.find(".gb-change-variant_id option:selected");
      if (selectedOption.length > 0) productId = selectedOption.data("variant-id");
    } else if (parentBlock.find(".product-variant-id").length > 0) { productId = parentBlock.find(".product-variant-id").val(); }
    else if ($(this).data("variant-id")) { productId = $(this).data("variant-id"); }
    if (this.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) { console.error("Missing product ID for frequently bought product"); e.preventDefault(); return false; }
    if (idInput.length === 0) { $("<input>").attr({ type: "hidden", name: "id", value: productId }).appendTo(parentBlock); }
    else { idInput.val(productId); }
    let quantityInput = parentBlock.find('input[name="quantity"]');
    if (quantityInput.length === 0) { $("<input>").attr({ type: "hidden", name: "quantity", value: 1 }).appendTo(parentBlock); }
    else if (!quantityInput.val() || quantityInput.val() < 1) { quantityInput.val(1); }
  });
});

// Product image sliders are now handled by snippets/cart-drawer-script.liquid
// (initProductImageSliders — uses data-ps2-init, loop, real-time drag, hover suppression)
